"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveEntriesExpression = exports.resolveMergeExpression = exports.resolveObjectExpression = void 0;
var object_1 = require("./object");
Object.defineProperty(exports, "resolveObjectExpression", { enumerable: true, get: function () { return object_1.resolveObjectExpression; } });
var merge_1 = require("./merge");
Object.defineProperty(exports, "resolveMergeExpression", { enumerable: true, get: function () { return merge_1.resolveMergeExpression; } });
var entries_1 = require("./entries");
Object.defineProperty(exports, "resolveEntriesExpression", { enumerable: true, get: function () { return entries_1.resolveEntriesExpression; } });
//# sourceMappingURL=index.js.map